import React from "react";

const displayName = (patient) => {
	if (!patient) return;

	return (
		<b>
			<span style={{ textTransform: "uppercase" }}>
				{patient.birth_name ?? patient.last_name} {patient.married_name || patient.marital_name ? "-" : ""}{" "}
				{patient.married_name ?? patient.marital_name}
			</span>{" "}
			{patient.first_name}
		</b>
	);
};

export const getFullName = (patient) => {
	return `${patient?.birth_name?.toUpperCase()}${patient?.married_name ? ` - ${patient?.married_name?.toUpperCase()}` : ""} ${patient?.first_name}`;
};

export const getFullNameAndMatricule = (patient) => {
	const isFastlinePatient = patient?.first_name === "Register" && patient?.birth_name === "Line";
	if (isFastlinePatient) return "Patient à associer au dossier";

	let patientName = `${patient?.birth_name?.toUpperCase()}${patient?.married_name ? ` - ${patient?.married_name?.toUpperCase()}` : ""} ${
		patient?.first_name
	}`;

	if (patient && !!patient.cns) {
		patientName = patientName.concat(` (${patient?.cns})`);
	}

	return patientName;
};

export default displayName;
